import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { jobsActions } from '../../../../../store/slices/jobTally'

import { Button, Modal } from '../../../../../../../components/Common'

const RemoveModal = ({ show, toggle, job }) => {
  const dispatch = useDispatch()

  const handleRemoveJob = (jobID) => {
    dispatch(jobsActions.jobRemoved(jobID))
    toggle()
  }

  return (
    <Modal
      className="job-modal"
      show={show}
      onHide={toggle}
      footer={
        <Modal.Footer>
          <div className="w-full d-flex justify-center items-center gap-x-4">
            <Button
              className="button -xsmall"
              variant="text"
              onClick={() => handleRemoveJob(job.uid)}
            >
              <span className="material-icons">delete</span>
              <span className="button__text">Delete</span>
            </Button>
            <Button className="button -xsmall" variant="text" onClick={toggle}>
              <span className="material-icons">close</span>
              <span className="button__text">Close</span>
            </Button>
          </div>
        </Modal.Footer>
      }
    >
      <p className="d-flex justify-center items-center mt-0 py-8">
        {`Are you sure you want to delete ${job.uid}`}
      </p>
    </Modal>
  )
}

RemoveModal.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  job: PropTypes.objectOf(PropTypes.any),
}

export default RemoveModal
